import React, { useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { addToTbr, normalizeTbrBook, useTbr } from "../../services/tbrStore";
import { displayLabel } from "../../utils/displayLabel";

export default function TbrButton({ book, productUrl, coverImageUrl }) {
  const { books, pending, status } = useTbr();
  const [error, setError] = useState("");
  const entry = normalizeTbrBook(book, { productUrl, coverImageUrl });
  const saved = books.some(item => item.productUrl === entry.productUrl);
  const busy = pending[entry.productUrl] || status === "loading";
  const label = busy ? "Saving or loading TBR" : saved ? "Saved to TBR" : "Add to TBR";
  const handleSave = async event => {
    event.preventDefault();
    event.stopPropagation();
    setError("");
    if (saved) return;
    try { await addToTbr(entry); }
    catch (failure) {
      if (failure.code === "READER_SIGN_IN_REQUIRED") {
        window.location.assign(`/loginreader?returnTo=${encodeURIComponent(window.location.href)}`);
      } else setError(failure.message);
    }
  };
  return (
    <div className="relative shrink-0">
      <button type="button" aria-label={`${label}: ${displayLabel(entry.title)}`} aria-pressed={saved}
        disabled={busy} title={label} onClick={handleSave}
        className={`inline-flex min-h-[44px] min-w-[44px] shrink-0 items-center justify-center gap-2 rounded-full border border-bookish-purple/30 px-3 py-2 text-sm font-semibold text-bookish-purple transition hover:bg-bookish-purple/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-bookish-purple disabled:opacity-60 ${saved ? "bg-bookish-purple/10" : "bg-white"}`}>
        <span>TBR</span>
        {busy ? <Loader2 size={16} aria-hidden="true" className="animate-spin" /> : saved ? <Check size={16} aria-hidden="true" /> : null}
      </button>
      {error && <p role="alert" className="absolute bottom-full left-0 z-10 mb-2 w-48 rounded-md border border-red-200 bg-white p-2 text-xs text-red-700 shadow">{error}</p>}
    </div>
  );
}
